var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05983 2.34362L8.65638 4.94078L2.59655 11H0V8.40284L6.05983 2.34301V2.34362ZM6.92535 1.4781L8.22362 0.179216C8.33841 0.0644641 8.49407 0 8.65638 0C8.81869 0 8.97435 0.0644641 9.08914 0.179216L10.8208 1.91086C10.9355 2.02565 11 2.18131 11 2.34362C11 2.50593 10.9355 2.66159 10.8208 2.77638L9.5219 4.07465L6.92535 1.4781Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.ada5c163ace1748bd993b5055fc1e39d.svg";
export { ForwardRef as ReactComponent };